import { render } from "./SubmitFormFull.vue?vue&type=template&id=2ba894e7&scoped=true&ts=true"
import script from "./SubmitFormFull.vue?vue&type=script&lang=ts"
export * from "./SubmitFormFull.vue?vue&type=script&lang=ts"

import "./SubmitFormFull.vue?vue&type=style&index=0&id=2ba894e7&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2ba894e7"]])

export default __exports__